import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";

import { useNavigate, useLocation } from "react-router-dom";

import CustomModal from "../../components/CustomModal";
import Banner from "../../components/Banner";

import * as Material from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import api from "../../helpers/api.js";

import Config, { token } from "../../config.js";

import "./styles.css";

import { ReactComponent as MeasureIcon } from "../../assets/custom-icons/measuring-tape.svg";
import { ReactComponent as VerifiedIcon } from "../../assets/custom-icons/verify.svg";
import AddIcon from "@mui/icons-material/Add";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SendIcon from "@mui/icons-material/Send";
import EditIcon from "@mui/icons-material/Edit";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckIcon from "@mui/icons-material/Check";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import TuneIcon from "@mui/icons-material/Tune";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";

import dayjs, { Dayjs } from "dayjs";

import networkGif from "../../assets/animations/network.gif";

import ReactCrop, {
  centerCrop,
  makeAspectCrop,
  Crop,
  PixelCrop,
  convertToPixelCrop,
} from "react-image-crop";

import "react-image-crop/dist/ReactCrop.css";

import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";

import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import Screen from "../../components/Screen";

import MainButton from "../../components/SmallComponents/MainButton";

import { useChallenge } from "../../contexts/ChallengeContext";

export default function ProfilePage() {
  document.title = "Dinastia | Ginastee";

  const [loadingChallenge, setLoadingChallenge] = useState(true);

  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
  }, [pathname]);

  return (
    <Screen title="Configurar desafio">
      <div className="page-content pt-7">
        <ChallengeConfig
          loadingChallenge={loadingChallenge}
          setLoadingChallenge={setLoadingChallenge}
        />
      </div>
    </Screen>
  );
}

function ChallengeConfig({
  loadingChallenge = false,
  setLoadingChallenge = () => {},
  creationMode = false,
  onCreated=() => {}
}) {
  const [snackbarMessage, setSnackbarMessage] = useState();

  const { currentChallenge, setLoading } = useChallenge();
  console.log("Loading", loadingChallenge);

  let location = useLocation();
  let navigate = useNavigate();

  const [banner, setBanner] = useState("");

  const [name, setName] = useState("");

  const [saving, setSaving] = useState(false);

  const [description, setDescription] = useState("");

  const [displayAwards, setDisplayAwards] = useState(false);
  const REF_awards = useRef([
    {
      banner: "",
      text: "",
    },
  ]);

  const [startAt, setStartAt] = useState(dayjs());

  const [duration, setDuration] = useState(30);

  const REF_descriptionLinks = useRef();

  useEffect(() => {
    if (loadingChallenge && !creationMode) {
      loadPageData();
    }
  }, [loadingChallenge]);

  useEffect(() => {
    setLoadingChallenge(true);
  }, [currentChallenge]);

  useEffect(() => {
    console.log(startAt)
  }, [startAt])

  async function loadPageData() {
    try {
      const result = await api.get(
        "/challenge?challenge_id=" + currentChallenge?.challenge_id
      );

      if (result.data) {
        const info = result.data;
        REF_awards.current = [...info.awards];
        setDisplayAwards(!!info.display_awards);
        setName(info.name);
        setDescription(info.description);
        setBanner(info.banner);
        setDuration(info.duration);
        if(info?.started_at){
          setStartAt(dayjs(info.started_at));
        } else {
          setStartAt(dayjs());
        }
        REF_descriptionLinks.current = info.description_links || [];
      }
    } catch (e) {
      console.log(e);
    }

    setLoadingChallenge(false);
  }
  async function handleSave() {
    const formValues = {
      name: name?.trim(),
      description: description?.trim(),
      duration,
      awards: REF_awards.current,
      display_awards: displayAwards,
      started_at: dayjs(startAt).format('YYYY-MM-DD'),
      challenge_id: currentChallenge?.challenge_id,
      description_links:
        REF_descriptionLinks.current?.filter(
          (v) => !!v.title?.trim() && !!v.link?.trim()
        ) || [],
    };

    if(banner && !banner.includes('https://')){
      formValues.banner_data = banner
    }

    setSaving(true);

    try {
      const result = await api[creationMode ? "post" : "patch"](
        "/challenge",
        formValues
      );
      console.log(result.data);
      if (result.data.success) {
        window.setSnackbar("Desafio salvo com sucesso");
        onCreated(result.data)
        setLoading(true);
        window.navigate("/");
      }
    } catch (e) {
      console.error(e);
    }

    setSaving(false);
  }

  if (loadingChallenge) return <></>;

  return (
    <>
      <div className="body-content pb-8 px-2 ">
        <Avatar
          uploading={false}
          onLoadNewAvatar={(e) => setBanner(e)}
          src={banner}
          loading={loadingChallenge}
        />
        <div className="profile-column mt-4">
          <Material.TextField
            className={"counter-input fade delay-1 mb-2"}
            disabled={loadingChallenge}
            value={name || ""}
            onInput={(e) => setName(e.target.value)}
            color="primary"
            InputLabelProps={{ shrink: true }}
            label="Nome do desafio"
            error={name?.length > 25}
            helperText={"" + (name?.length || 0) + "/25"}
            fullWidth
          />
          <Material.TextField
            className={"counter-input fade delay-3"}
            disabled={loadingChallenge}
            value={description || ""}
            onInput={(e) => setDescription(e.target.value)}
            color="primary"
            label="Descrição (opcional)"
            InputLabelProps={{ shrink: true }}
            multiline
            rows={3}
            error={description?.length > 250}
            helperText={"" + (description?.length || 0) + "/250"}
            fullWidth
          />

          <DescriptionLinks values={REF_descriptionLinks} />

          <Material.Typography variant="h4" className="mt-2">
            Duração
          </Material.Typography>




          <Material.Typography variant="h3" className="">
            Premiações
          </Material.Typography>
          <FormControlLabel
            control={
              <Switch
                checked={displayAwards}
                onChange={(v) => setDisplayAwards(v.target.checked)}
                defaultChecked
                color="primary"
              />
            }
            label="Mostrar premiações"
          />
          {displayAwards && <Awards valuesRef={REF_awards} />}
          <MainButton
            color="primary"
            className="mt-4 save-btn"
            size="large"
            onClick={handleSave}
            disabled={saving}
            endIcon={<AddIcon />}
            label="Salvar alterações"
          />
        </div>
      </div>
    </>
  );
}

export { ChallengeConfig };

const DescriptionLinks = ({ values }) => {
  const [links, setLinks] = useState(values.current);

  const LinkInfo = ({ data, index }) => {
    const [title, setTitle] = useState(data.title);
    const [link, setLink] = useState(data.link);

    return (
      <div className="link-info-block mt-2">
        <Material.TextField
          className={"counter-input mt-2"}
          value={title}
          onInput={(e) => {
            const linkCopy = [...values.current];
            linkCopy[index].title = e.target.value;
            values.current = [...linkCopy];
            setTitle(e.target.value);
          }}
          color="primary"
          label="Título do link"
          InputLabelProps={{ shrink: true }}
          placeholder="O título do link será o texto do botão no app"
          error={title?.length > 25}
          helperText={"" + (title?.length || 0) + "/25"}
          fullWidth
        />
        <Material.TextField
          className={"counter-input mt-1"}
          value={link}
          onInput={(e) => {
            const value = e.target.value;
            const linkCopy = [...values.current];
            linkCopy[index].link = value;
            values.current = [...linkCopy];
            setLink(value);
          }}
          InputProps={{
            startAdornment: (
              <Material.InputAdornment position="start">
                <label>https://</label>
              </Material.InputAdornment>
            ),
          }}
          color="primary"
          label="Link"
          fullWidth
        />
        <Material.IconButton
          onClick={() => {
            const linkCopy = [...values.current];
            linkCopy.splice(index, 1);
            setLinks([...linkCopy]);
          }}
          className="delete-link-btn"
        >
          <DeleteIcon color="error" />
        </Material.IconButton>
      </div>
    );
  };

  return (
    <div className="description-links mt-2 pb-3">
      <h4>Links na descrição</h4>
      {links?.map((linkInfo, i) => (
        <LinkInfo data={linkInfo} key={i} index={i} />
      ))}
      <MainButton
        color="primary"
        className="mt-2 save-btn"
        onClick={() => {
          const linksCopy = [...links];
          linksCopy.push({ title: "", link: "" });
          setLinks([...linksCopy]);
          values.current = [...linksCopy];
        }}
        small
        disabled={links?.length >= 3}
        endIcon={<AddIcon />}
        label="Adicionar link"
      />
    </div>
  );
};

const Awards = ({ valuesRef }) => {
  const [awards, setAwards] = useState(valuesRef.current);

  useEffect(() => {
    valuesRef.current = [...awards];
  }, [awards]);

  function handleTitleInput(value, i) {
    const awardsCopy = [...awards];
    awardsCopy[i].text = value;
    setAwards([...awardsCopy]);
  }
  function handleAddBanner(image, i) {
    const awardsCopy = [...awards];
    awardsCopy[i].banner = image;
    setAwards([...awardsCopy]);
  }
  function handleRemove(i) {
    const awardsCopy = [...awards];
    awardsCopy.splice(i, 1);
    setAwards([...awardsCopy]);
  }
  function handleAddAward() {
    const awardsCopy = [...awards];
    awardsCopy.push({
      banner: "",
      text: "",
    });
    setAwards([...awardsCopy]);
  }

  return (
    <div className="awards-list mt-1">
      {awards.map((award, i) => {
        return (
          <div className="award-row mt-3" key={i}>
            <Avatar
              key={Math.random()}
              loading={false}
              src={award.banner}
              onLoadNewAvatar={(e) => handleAddBanner(e, i)}
              className=""
            />
            <Material.TextField
              className={"counter-input fade delay-1"}
              value={award.text || ""}
              onInput={(e) => handleTitleInput(e.target.value, i)}
              color="primary"
              label="Nome do prêmio"
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <IconButton onClick={() => handleRemove(i)} aria-label="delete">
              <DeleteIcon />
            </IconButton>
          </div>
        );
      })}
      <Button
        variant="text"
        onClick={handleAddAward}
        size="small"
        className="mt-3"
        startIcon={<AddIcon />}
      >
        Adicionar prêmio
      </Button>
    </div>
  );
};

const Avatar = ({ loading, uploading, src, onLoadNewAvatar }) => {
  const inputRef = useRef();
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [crop, setCrop] = useState({
    unit: "px",
    aspect: 1,
    width: 150,
    height: 150,
  });
  const [preview, setPreview] = useState(src);
  const imageRef = useRef();

  const REF_cropArea = useRef()


  const onCropComplete = (crop) => makeClientCrop(crop);
  const onCropChange = (crop) => {
    console.log(crop)
    setCrop({...crop})
  };

  async function makeClientCrop(crop) {
    console.log('Crop', crop)
    if (imageRef.current && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        imageRef.current,
        crop,
        "newFile.jpeg"
      );
      setPreview(croppedImageUrl);
    }
  }

  function getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width * scaleX;
    canvas.height = crop.height * scaleY;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          return;
        }
        blob.name = fileName;
        window.URL.revokeObjectURL(preview);
        resolve(window.URL.createObjectURL(blob));
      }, "image/jpeg");
    });
  }

  const handleImageChange = (event) => {
    setCropModalOpen(true);
    const file = event.target.files[0];

    if (file) {
      if (file.size > 50 * 1024 * 1024) {
        event.target.value = null;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const base64String = e.target.result;
        event.target.value = null;
        setSelectedImage(base64String);
        setPreview(base64String);
      };

      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <div
        className="profile-photo sh-1"
        onClick={() => {
          inputRef.current?.click();
        }}
      >
        {loading && (
          <Material.Skeleton
            style={{ zIndex: 99, top: 0, left: 0 }}
            variant="rectangular"
            width={210}
            height={60}
          />
        )}

        {preview && <img src={preview || src} alt="Cropped" />}

        <div className={"edit-btn-area " + (!preview && "empty")}>
          <AddAPhotoIcon className="add-photo-icon" color="white" />
        </div>

        <input
          accept="image/png, image/jpeg, image/jpg"
          ref={inputRef}
          style={{ visibility: "hidden", height: 0, width: 0 }}
          type="file"
          onChange={handleImageChange}
        />
      </div>
      <Material.Modal
        open={cropModalOpen}
        onClose={() => setCropModalOpen(false)}
        className="avatar-crop-modal px-1 py-2"
      >
        <Material.Box
          sx={{
            maxWidth: 500,
          }}
        >
          <div className="px-2">
            <Material.Typography variant="h6" component="h4">
              Foto de perfil
            </Material.Typography>
          </div>

          {selectedImage && (
            <div className="image-crop-preview mt-2">
              <ReactCrop
                ref={REF_cropArea}
                aspect={1}
                src={selectedImage}
                crop={crop}
                ruleOfThirds
                onComplete={onCropComplete}
                onChange={onCropChange}
              >
                <img
                  ref={imageRef}
                  src={selectedImage}
                  alt="Crop"
                  width="100%"
                />
              </ReactCrop>
            </div>
          )}
          <div className="px-2">
            <Material.Button
              variant="contained"
              color="primary"
              style={{ width: "100%" }}
              className="mt-2"
              onClick={async () => {
                fetch(preview)
                  .then((response) => response.blob())
                  .then((blob) => {
                    const reader = new FileReader();

                    reader.onload = (event) => {
                      const base64Image = event.target.result;
                      onLoadNewAvatar(base64Image);
                      setCropModalOpen(false);
                    };

                    reader.readAsDataURL(blob);
                  })
                  .catch((error) => {
                    console.error("Error fetching Blob data:", error);
                  });
              }}
            >
              Salvar
            </Material.Button>
          </div>
        </Material.Box>
      </Material.Modal>
    </>
  );
};
